import { Flex, Heading, Text, FlexProps, Box } from '@chakra-ui/react';
import { colors } from 'theme/colors';
import React, { memo } from 'react';
import { CustomIcon } from 'components';

interface IProps extends FlexProps {
  text: String;
  titulo: String;
  error?: Boolean;
}

const ConclusionResponsesComponent: React.FC<IProps> = ({
  text,
  error = false,
  titulo,
  ...props
}) => {
  return (
    <Box>
      <Heading textColor={colors.brand[1400]} textStyle="bold" fontSize="14px">
        ⦁ {titulo}
      </Heading>
      <Flex
        borderRadius="4px"
        mt="10px"
        mb="20px"
        p="16px"
        border="1px solid"
        borderColor="brand.gray600"
        backgroundColor={error ? 'brand.warning' : ''}
        {...props}
      >
        {error ? (
          <Box marginRight="5px" marginTop="auto" marginBottom="auto">
            <CustomIcon icon="info_outline" size="20px" color="brand.red200" $noSphere />
          </Box>
        ) : null}
        <Text
          fontSize="14px"
          color={error ? colors.brand[1400] : colors.brand[900]}
          fontStyle="italic"
          mt="auto"
          mb="auto"
        >
          {text}
        </Text>
      </Flex>
    </Box>
  );
};

export const ConclusionResponses = memo(ConclusionResponsesComponent);
